import moment from 'moment';

export default class BlockedNumberService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    ngAuthSettings,
    cacheService
  ) {
    this.$http = $http;
    this.$q = $q;
    this.ngAuthSettings = ngAuthSettings;
    this.cacheService = cacheService;
  }

  saveBlockedNumber(accountId, blockedNumber) {
    blockedNumber = this.#transformBlockNumberToDTO(blockedNumber);

    return this.getBlockedNumbers(accountId).then((blockedNumbers) => {
      const number = _.find(blockedNumbers, (no) => {
        return no.phoneNumber === blockedNumber.phoneNumber && no.campaignId === blockedNumber.campaignId && moment(no.expiration).diff(moment()) > 0;
      });

      if (number) {
        let message = 'The number has already been blocked for ';
        message += blockedNumber.campaignId ? 'the same campaign' : 'all campaigns';
        return this.$q.reject({
          data: {
            message: message
          }
        });
      } else {
        return this.$http.post(this.#getBaseUrl(accountId), blockedNumber);
      }

    }).then((response) => {
      this.#removeBlockedNumbersFromCache(accountId);
      return response.data.blockedNumber;
    });

  }

  saveMultipleBlockedNumbers(accountId, blockedNumbers) {
    blockedNumbers = blockedNumbers.map((number) => {
      return this.#transformBlockNumberToDTO(number);
    });

    return this.getBlockedNumbers(accountId).then((existingBlockedNumber) => {
      const blockNumberRequests = [];

      blockedNumbers.forEach((number) => {
        const foundNumber = _.find(existingBlockedNumber, (no) => {
          return no.phoneNumber === number.phoneNumber && no.campaignId === number.campaignId && moment(no.expiration).diff(moment()) > 0;
        });

        if (foundNumber) {
          let message = 'The number has already been blocked for ';
          message += number.campaignId ? 'the same campaign' : 'all campaigns';
          blockNumberRequests.push(this.$q.reject({
            data: {
              message: message
            }
          }));
        } else {
          blockNumberRequests.push(this.$http.post(this.#getBaseUrl(accountId), number));
        }
      });

      return Promise.allSettled(blockNumberRequests);
    }).then((response) => {
      this.#removeBlockedNumbersFromCache(accountId);

      return response?.filter((promiseResult) => promiseResult.status === 'fulfilled')
        .map((promiseResult) => {
          return promiseResult.value.data.blockedNumber;
        });
    });

  }

  updateBlockedNumber(accountId, blockedNumber) {
    const newBlockedNumber = this.#transformBlockNumberToDTO(blockedNumber);
    newBlockedNumber.id = blockedNumber.id;
    return this.$http.patch(this.#getBaseUrl(accountId) + blockedNumber.id, newBlockedNumber)
      .then((response) => {
        this.#removeBlockedNumbersFromCache(accountId);
        return response.data.blockedNumber;
      });
  }

  getBlockedNumbers(accountId) {
    const cachedValue = this.cacheService.get(this.#getCacheKey(accountId));
    if (cachedValue) {
      return this.$q.when(angular.copy(cachedValue));
    }

    return this.#getBlockedNumbersFromServer(accountId)
      .then((blockedNumbers) => {
        return blockedNumbers;
      });
  }

  getBlockedNumber(accountId, blockedNumberId) {
    return this.$http.get(this.#getBaseUrl(accountId) + blockedNumberId).then((response) =>{
      return response.data.blockedNumber;
    });
  }

  deleteBlockedNumber(accountId, blockedNumberId) {
    return this.$http.delete(this.#getBaseUrl(accountId) + blockedNumberId).then((response) => {
      this.#removeBlockedNumbersFromCache(accountId);
      return response.data;
    });
  }

  #getBlockedNumbersFromServer(accountId) {
    return this.$http.get(this.#getBaseUrl(accountId)).then((response) => {
      this.cacheService.set(this.#getCacheKey(accountId), response.data.blockedNumbers, {
        persistence: false
      });
      return response.data.blockedNumbers;
    }, () => []);
  }

  #removeBlockedNumbersFromCache(accountId) {
    this.cacheService.remove(this.#getCacheKey(accountId));
  }

  #transformBlockNumberToDTO(blockedNumber) {
    const expiration = blockedNumber.id && blockedNumber.enableBlockTimePeriod ? moment(blockedNumber.createdDate).add(blockedNumber.expInHour, 'hour') : undefined;

    return {
      phoneNumber: blockedNumber.blockAnonymousCallers ? '+anonymous' : blockedNumber.phoneNumber,
      campaignId: blockedNumber.blockAllCampaigns ? '' : blockedNumber.campaignId,
      expInHour: !blockedNumber.id ? blockedNumber.expInHour : undefined,
      expiration: expiration,
      timeLimited: blockedNumber.id ? !!expiration : undefined
    };
  }


  #getBaseUrl(accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/blockedNumbers/';
  }

  #getCacheKey(accountId) {
    return 'blockedNumbers-' + accountId;
  }
}
